import React from 'react';
import ClientDashboard from './ClientDashboard';
import VADashboard from './VADashboard';
import AdminDashboard from './AdminDashboard';

const RoleBasedDashboard = () => {
  // Get user from localStorage
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const role = user.role || 'client';

  // Render dashboard based on role
  const renderDashboard = () => {
    switch (role) {
      case 'va':
        return <VADashboard />;
      case 'admin':
        return <AdminDashboard />;
      case 'client':
      default:
        return <ClientDashboard />;
    }
  };

  return (<>{renderDashboard()}</>);
};

export default RoleBasedDashboard;
